<template>
  <v-layout align-center justify-center row fill-height>
    <v-btn color="error" dark large v-on:click="signInWithGoogle">
        <i class="fa fa-google fa-lg"></i> Login with Google
    </v-btn>
  </v-layout>
</template>

<script>
import { fb } from '../services/firebase'
import User from '../services/user';
import store from '../store';

export default {
  name: 'Login',
  data() {
    return {
    
    }
  },
  methods: {
    signInWithGoogle: function () {
        const provider = new fb.auth.GoogleAuthProvider();
        fb.auth().signInWithPopup(provider).then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const token = result.credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            store.commit('setUserAuthData', user.toJSON());
            this.$router.push('/');
        }).catch(function(error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            const credential = error.credential;
            // ...
        });
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
